import {
    CLIENT_TYPES,
    ENV_TYPES,
    ROUTES,
    CLIENT_LETTERS
} from '../_constants';
import { CLIENT_CONFIGS } from './clientConfigs';
import { type ClientName } from '../../types/index';

const APP_ENV = import.meta.env.VITE_APP_ENV || ENV_TYPES.INT;

export const CLIENT_NAME = import.meta.env.VITE_CLIENT_NAME
    ? import.meta.env.VITE_CLIENT_NAME.toLowerCase()
    : (CLIENT_TYPES.AUDI as ClientName);

export const BRAND_LETTER = CLIENT_LETTERS[CLIENT_NAME];

export const isBentley = CLIENT_NAME === 'bentley';
export const isCupra = CLIENT_NAME === 'cupra';
export const isVolkswagen = CLIENT_NAME === 'volkswagen';
export const isAudi = CLIENT_NAME === 'audi';

export const ENV = APP_ENV.toLowerCase()

const clientConfigs = CLIENT_CONFIGS[CLIENT_NAME];

const appHistory = {
    push: (to: string | { pathname?: string; search?: string }) => {
        const pathname = typeof to === 'string' ? to : to?.pathname || '/';
        const search = typeof to === 'string' ? '' : to?.search || '';
        const nextLocation = `${pathname}${search}`;

        if (window.location.pathname + window.location.search !== nextLocation) {
            window.location.assign(nextLocation);
        }
    }
};

const globalConfigs = {
    ...clientConfigs,
    version: import.meta.env.VITE_APP_VERSION || '0.0.0',
    history: appHistory,
    defaultUrls: {
        authenticated: ROUTES.DASHBOARD,
        onboardingPage: ROUTES.ONBOARDING,
        noAuthenticated: ROUTES.NO_AUTHENTICATED,
        connect: ROUTES.CONNECT,
        grp: ROUTES.GRP,
        register:
            CLIENT_NAME === 'audi' ? '/register' : `/register/${CLIENT_NAME}`,
        resetPassword:
            CLIENT_NAME === 'audi'
                ? '/resetting/request'
                : `/resetting/request?brand=${CLIENT_NAME}`
    },
    overrideSessionTimeout: null,
    alertDuration: 4500,
    defaultMediaStyle: 'grid',
    maxPdfViewerSize: 2048000,
    mediaTypes: {
        image: 'image',
        video: 'video',
        audio: 'audio',
        document: 'document'
    },
    categories: [
        {
            value: 'Audi Sport',
            label: {
                en_US: 'Audi Sport',
                de_DE: 'Audi Sport'
            }
        },
        {
            value: 'Used Cars',
            label: {
                en_US: 'Used Cars',
                de_DE: 'Gebrauchtwagen'
            }
        },
        {
            value: 'Models and Technologies',
            label: {
                en_US: 'Models & Technologies',
                de_DE: 'Modelle & Technologien'
            }
        },
        {
            value: 'Brand',
            label: {
                en_US: 'Brand',
                de_DE: 'Marke'
            }
        },
        {
            value: 'After Sales',
            label: {
                en_US: 'After Sales',
                de_DE: 'After Sales'
            }
        },
        {
            value: 'Motorsport',
            label: {
                en_US: 'Motorsport',
                de_DE: 'Motorsport'
            }
        }
    ],
    languages: [
        {
            key: 'english',
            count: 1
        },
        {
            key: 'french',
            count: 1
        },
        {
            key: 'german',
            count: 1
        },
        {
            key: 'portugese',
            count: 1
        },
        {
            key: 'spanish',
            count: 1
        },
        {
            key: 'uk',
            count: 1
        }
    ],
    countries: [
        {
            key: 'brazil',
            count: 1
        },
        {
            key: 'france',
            count: 1
        },
        {
            key: 'germany',
            count: 1
        },
        {
            key: 'portugal',
            count: 1
        },
        {
            key: 'spain',
            count: 1
        },
        {
            key: 'uk',
            count: 1
        }
    ],
    pinPairDisabledCountries: [
        'NZL',
        'LVA',
        'LTH',
        'IRL',
        'EST',
        'DNK',
        'CYP',
        'GRC',
        'TWN',
        'KOR',
        'MEX',
        'CRI',
        'LUX',
        'ROU',
        'SVK',
        'CHE',
        'TUR',
        'BHR',
        'SAU',
        'ARE',
        'OMN',
        'QAT',
        'KWT',
        'LBN',
        'JOR',
        'AUS',
        'BGR',
        'HRV',
        'HUN',
        'NOR',
        'SWE',
        'ZAF',
        'JPN',
        'ESP',
        'FRA',
        'GBR',
        'DEU',
        'BEL'
    ],
    welcomeScreenEnabledCountries: [
        'DEU',
        'GBR'
    ],
    welcomeScreenEnabledCountriesExperimental: [
        'DEU',
        'GBR'
    ]
};

export { globalConfigs };
export default globalConfigs;
